export enum ActionbarMode {
  Dock = 'dock',
  Overlay = 'overlay',
  Context = 'context'
}
